import { useFlags } from "launchdarkly-react-client-sdk";
import React, { useContext } from "react";
import { AppContext } from "../app/store";
import { useTranslate } from "../helpers";
import {
  TealiumEventProps,
  sendTealiumEvent,
  createGa4Event,
  Ga4Event,
} from "../helpers/analytics";

interface PrintButtonProps {
  tealiumProps?: TealiumEventProps;
  onClick?: () => void;
  className?: string;
}

export const printPage = (): void => {
  // For some reason, window.print is not working in Safari even though it's a supported function
  if (!document.execCommand("print", false, undefined)) {
    window.print();
  }
};

const PrintButton: React.FunctionComponent<PrintButtonProps> = ({
  children,
  tealiumProps,
  onClick,
  className,
  ...props
}) => {
  const t = useTranslate();
  const { state } = useContext(AppContext);
  const flags = useFlags();

  return (
    <button
      onClick={
        onClick ||
        ((): void => {
          if (tealiumProps)
            // istanbul ignore next: tested elsewhere
            sendTealiumEvent(
              tealiumProps.event_action,
              tealiumProps.event_label,
              tealiumProps.additional_props
            );

          createGa4Event({ event_name: Ga4Event.PRINT, state, flags });

          printPage();
        })
      }
      className={`PrintButton mct-hide-print ${className}`}
      {...props}
    >
      <span className="fa fa-print fa-lg" />
      <div>{children || t("print")}</div>
    </button>
  );
};

export default PrintButton;
